import { Component, Inject } from "@angular/core";
import { FormBuilder, FormControl, Validators } from "@angular/forms";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { DialogBase, ServiceGuyInfo } from "t4core";
import { ItemInfo } from "t4core";

@Component({
  selector: 'updateStockDialog',
  templateUrl: 'updateStockDialog.html',
  styleUrls: ['./updateStockDialog.css']
})
export class UpdateStockDialog extends DialogBase {
  public guy: ServiceGuyInfo;
  public items: ItemInfo[];
  public orderValue: number;

  constructor(

    private dialog: MatDialog,
    public dialogRef: MatDialogRef<UpdateStockDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder
  ) {
    super("UpdateStockDialog");

  
    if (data) {
      this.guy = data.guy;
    }
  }

  public async ngOnInit() {
    this.getItems();
  }

  public async getItems() {
    var token = this.beginLoad('Turbo.OneWayAdmin.ServiceDialog.msgLoadingServiceGuystockItems', 'Loading Stock items', null);
    this.items = await this.Api.get<ItemInfo[]>("/ServiceService/GetStockItems", { serviceGuyId: this.guy.Id });  

    this.endLoad(token);
  }

  public async save() {
    var data = this.items.filter(x => x.OrderAmount != 0);

    await this.Api.post<boolean>("/ServiceService/UpdateStock", data, { serviceGuyId: this.guy.Id });
    this.dialogRef.close();
  }
}
